module.exports = __webpack_public_path__ + "static/img/3.5c090e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/oem/R142B/3.jpg
// module id = OsvU
// module chunks = 1